<div class="container">
  <mat-tab-group
    [selectedIndex]="selected.value"
    (selectedTabChange)="selected.setValue($event.index)"
  >
  <mat-tab label="Rutas">
    <div class="container mt-4">
      <div class="container-toggle">
        <mat-slide-toggle class="toggle" (change)="changeToggle($event)" [(ngModel)]="isChecked">{{labelToggle}}</mat-slide-toggle>
      </div>
      <data-table
      *ngIf="isChecked"
      [title]='"Rutas Activas"'
      [columns]='routeColumnsTable'
      [configuration]='routeConfigurationTable'
      [reloadTable]='reloadRouteTable'
      [params]='params'
      [url]='urlGetRoutes'
      (active)="inactivateOrActiveRouter ($event, false)"
      (add)='addRouter($event)'
      (edit)='editRouter($event)'
      ></data-table>

      <data-table
      *ngIf="!isChecked"
      [title]='"Rutas Inactivas"'
      [columns]='routeColumnsTable'
      [configuration]='routeConfigurationInactive'
      [reloadTable]='reloadRouteInactiveTable'
      (active)="inactivateOrActiveRouter ($event, true)"
      [params]='params2'
      [url]='urlGetRoutes'
      ></data-table>
    </div>
  </mat-tab>

  <mat-tab *ngIf="selected.value == 1" label="{{ label }}">
    <div class="W-100 mt-3">
      <app-router-detail
        [locationRouteId]="locationRouteId"
        (completeRouter)="completeRouter($event)"
      >
      </app-router-detail>
    </div>
  </mat-tab>


  </mat-tab-group>
</div>


